import _slicedToArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["descending"];
import _regeneratorRuntime from "/opt/build/repo/gatsby/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// src/arrays.ts
function createArray(size) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Array.from({
    length: size
  }, function (_, index) {
    return index + start;
  });
}

function getRandomItem(input) {
  return input[Math.floor(Math.random() * input.length)];
}

function quickSort(input) {
  var comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sortComparator;

  var output = _toConsumableArray(input);

  var recursiveSort = function recursiveSort(start, end) {
    if (end - start < 1) {
      return;
    }

    var pivotValue = output[end];
    var splitIndex = start;

    for (var index = start; index < end; index++) {
      var sort = comparator(output[index], pivotValue);

      if (sort === -1) {
        if (splitIndex !== index) {
          var temp = output[splitIndex];
          output[splitIndex] = output[index];
          output[index] = temp;
        }

        splitIndex++;
      }
    }

    output[end] = output[splitIndex];
    output[splitIndex] = pivotValue;
    recursiveSort(start, splitIndex - 1);
    recursiveSort(splitIndex + 1, end);
  };

  recursiveSort(0, input.length - 1);
  return output;
}

function removeDuplicates(input) {
  return _toConsumableArray(new Set(input));
}

function shuffle(input) {
  var currentIndex = input.length;
  var randomIndex;
  var temporaryValue;

  var output = _toConsumableArray(input);

  while (currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex--);
    temporaryValue = output[currentIndex];
    output[currentIndex] = output[randomIndex];
    output[randomIndex] = temporaryValue;
  }

  return output;
}

function sortByLocaleCompare(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var descending = options.descending,
      compareOptions = _objectWithoutProperties(options, _excluded);

  if (key) {
    if (descending) {
      return function (left, right) {
        return right[key].toLowerCase().localeCompare(left[key].toLowerCase(), void 0, compareOptions);
      };
    }

    return function (left, right) {
      return left[key].toLowerCase().localeCompare(right[key].toLowerCase(), void 0, compareOptions);
    };
  }

  if (descending) {
    return function (left, right) {
      return right.toLowerCase().localeCompare(left.toLowerCase(), void 0, compareOptions);
    };
  }

  return function (left, right) {
    return left.toLowerCase().localeCompare(right.toLowerCase(), void 0, compareOptions);
  };
}

function sortByPrimitive(key) {
  var descending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var firstComparator = descending ? 1 : -1;
  var secondComparator = descending ? -1 : 1;

  if (key) {
    return function (left, right) {
      if (left[key] === right[key]) {
        return 0;
      }

      return left[key] < right[key] ? firstComparator : secondComparator;
    };
  }

  return function (left, right) {
    if (left === right) {
      return 0;
    }

    return left < right ? firstComparator : secondComparator;
  };
}

function sortComparator(left, right) {
  if (left < right) {
    return -1;
  }

  if (left > right) {
    return 1;
  }

  return 0;
}

function splitIntoChunks(input) {
  var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;

  if (!Array.isArray(input)) {
    throw new TypeError("expected an array for the first argument");
  }

  var chunks = [];

  for (var index = 0; index < Math.ceil(input.length / chunkSize); index++) {
    chunks.push(input.slice(index * chunkSize, (index + 1) * chunkSize));
  }

  return chunks;
} // src/async.ts


import is from "is-lite";
var ASYNC_STATUS = {
  IDLE: "IDLE",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR"
};

function cors(data) {
  var statusCodeOrOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

  var _ref = is.number(statusCodeOrOptions) ? {
    statusCode: statusCodeOrOptions
  } : statusCodeOrOptions,
      _ref$allowCredentials = _ref.allowCredentials,
      allowCredentials = _ref$allowCredentials === void 0 ? true : _ref$allowCredentials,
      _ref$allowedHeaders = _ref.allowedHeaders,
      allowedHeaders = _ref$allowedHeaders === void 0 ? [] : _ref$allowedHeaders,
      _ref$methods = _ref.methods,
      methods = _ref$methods === void 0 ? ["GET"] : _ref$methods,
      _ref$origin = _ref.origin,
      origin = _ref$origin === void 0 ? "*" : _ref$origin,
      _ref$responseHeaders = _ref.responseHeaders,
      responseHeaders = _ref$responseHeaders === void 0 ? void 0 : _ref$responseHeaders,
      _ref$statusCode = _ref.statusCode,
      statusCode = _ref$statusCode === void 0 ? 200 : _ref$statusCode;

  var allowMethods = [].concat(_toConsumableArray(methods), ["OPTIONS"]);

  var allowHeaders = _toConsumableArray( /* @__PURE__ */new Set(["Accept-Version", "Accept", "Authorization", "Content-Length", "Content-MD5", "Content-Type", "Date", "x-amz-date", "x-amz-security-token", "X-Api-Version", "X-CSRF-Token", "X-Requested-With"].concat(_toConsumableArray(allowedHeaders))));

  var exposedHeaders;

  if (responseHeaders) {
    exposedHeaders = _objectSpread({
      "Access-Control-Expose-Headers": Object.keys(responseHeaders).join(",")
    }, responseHeaders);
  }

  return {
    body: JSON.stringify(data),
    headers: _objectSpread({
      "Access-Control-Allow-Origin": origin,
      "Access-Control-Allow-Credentials": allowCredentials,
      "Access-Control-Allow-Methods": allowMethods.join(","),
      "Access-Control-Allow-Headers": allowHeaders.join(",")
    }, exposedHeaders),
    statusCode: statusCode
  };
}

function poll(_x) {
  return _poll.apply(this, arguments);
}

function _poll() {
  _poll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(condition) {
    var options,
        _options$delay,
        delay,
        _options$maxRetries,
        maxRetries,
        retries,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _options$delay = options.delay, delay = _options$delay === void 0 ? 1 : _options$delay, _options$maxRetries = options.maxRetries, maxRetries = _options$maxRetries === void 0 ? 5 : _options$maxRetries;
            retries = 0;

          case 3:
            if (!(!condition() && retries <= maxRetries)) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return sleep(delay);

          case 6:
            retries++;
            _context.next = 3;
            break;

          case 9:
            if (!(retries >= maxRetries)) {
              _context.next = 11;
              break;
            }

            throw new Error("Timeout");

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _poll.apply(this, arguments);
}

function request(_x2) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
    var options,
        body,
        headers,
        _options$method,
        method,
        params,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            body = options.body, headers = options.headers, _options$method = options.method, method = _options$method === void 0 ? "GET" : _options$method;

            if (url) {
              _context3.next = 4;
              break;
            }

            throw new Error("URL is required");

          case 4:
            params = {
              headers: _objectSpread({
                Accept: "application/json",
                "Content-Type": "application/json"
              }, headers),
              method: method
            };

            if (body) {
              params.body = is.plainObject(body) ? JSON.stringify(body) : body;
            }

            return _context3.abrupt("return", fetch(url, params).then( /*#__PURE__*/function () {
              var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
                var text, content, error;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return response.text();

                      case 2:
                        text = _context2.sent;

                        try {
                          content = JSON.parse(text);
                        } catch (_unused3) {
                          content = text;
                        }

                        if (!(response.status > 299)) {
                          _context2.next = 11;
                          break;
                        }

                        error = new Error(response.statusText);
                        error.status = response.status;
                        error.response = content;
                        throw error;

                      case 11:
                        return _context2.abrupt("return", content);

                      case 12:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x5) {
                return _ref13.apply(this, arguments);
              };
            }()));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _request.apply(this, arguments);
}

function sleep() {
  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return new Promise(function (resolve) {
    setTimeout(resolve, seconds * 1e3);
  });
} // src/date.ts


import is2 from "is-lite"; // src/strings.ts

function capitalize(input) {
  return input.charAt(0).toLocaleUpperCase() + input.slice(1).toLocaleLowerCase();
}

function cleanupHTML(input) {
  return removeWhitespace(removeEmptyTags(input));
}

function cleanupNumericString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return value.replace(/\D+/g, "");
}

function cleanupURI(input) {
  return input.replace(/[$&+,/:;=?@]/g, "");
}

function getInitials(input) {
  if (!input) {
    return "";
  }

  var names = input.trim().split(" ");

  if (names.length === 1) {
    return "".concat(names[0].charAt(0));
  }

  return "".concat(names[0].charAt(0)).concat(names[names.length - 1].charAt(0));
}

function pluralize(quantity, singular, plural) {
  if (quantity === 1) {
    return singular;
  }

  return plural || "".concat(singular, "s");
}

function removeAccents(input) {
  var removalMap = {
    A: /[AÀÁÂÃÄÅĀĂĄǍǞǠǺȀȂȦḀẠẢẤẦẨẪẬẮẰẲẴẶⒶＡ]/g,
    AA: /Ꜳ/g,
    AE: /[ÆǢǼ]/g,
    AO: /Ꜵ/g,
    AU: /Ꜷ/g,
    AV: /[ꜸꜺ]/g,
    AY: /Ꜽ/g,
    B: /[BƁƂɃḂḄḆⒷＢ]/g,
    C: /[CÇĆĈĊČƇȻḈⒸꜾＣ]/g,
    D: /[DĎĐƉƊƋḊḌḎḐḒⒹꝹＤ]/g,
    DZ: /[ǄǱ]/g,
    Dz: /[ǅǲ]/g,
    E: /[EÈÉÊËĒĔĖĘĚƎƐȄȆȨḔḖḘḚḜẸẺẼẾỀỂỄỆⒺＥ]/g,
    F: /[FƑḞⒻꝻＦ]/g,
    G: /[GĜĞĠĢƓǤǦǴḠⒼꝽꝾꞠＧ]/g,
    H: /[HĤĦȞḢḤḦḨḪⒽⱧⱵꞍＨ]/g,
    I: /[IÌÍÎÏĨĪĬĮİƗǏȈȊḬḮỈỊⒾＩ]/g,
    J: /[JĴɈⒿＪ]/g,
    K: /[KĶƘǨḰḲḴⓀⱩꝀꝂꝄꞢＫ]/g,
    L: /[LĹĻĽĿŁȽḶḸḺḼⓁⱠⱢꝆꝈꞀＬ]/g,
    LJ: /Ǉ/g,
    Lj: /ǈ/g,
    M: /[MƜḾṀṂⓂⱮＭ]/g,
    N: /[NÑŃŅŇƝǸȠṄṆṈṊⓃꞐꞤＮ]/g,
    NJ: /Ǌ/g,
    Nj: /ǋ/g,
    O: /[OÒÓÔÕÖØŌŎŐƆƟƠǑǪǬǾȌȎȪȬȮȰṌṎṐṒỌỎỐỒỔỖỘỚỜỞỠỢⓄꝊꝌＯ]/g,
    OI: /Ƣ/g,
    OO: /Ꝏ/g,
    OU: /Ȣ/g,
    P: /[PƤṔṖⓅⱣꝐꝒꝔＰ]/g,
    Q: /[QɊⓆꝖꝘＱ]/g,
    R: /[RŔŖŘȐȒɌṘṚṜṞⓇⱤꝚꞂꞦＲ]/g,
    S: /[SŚŜŞŠȘṠṢṤṦṨẞⓈⱾꞄꞨＳ]/g,
    T: /[TŢŤŦƬƮȚȾṪṬṮṰⓉꞆＴ]/g,
    TZ: /Ꜩ/g,
    U: /[UÙÚÛÜŨŪŬŮŰŲƯǓǕǗǙǛȔȖɄṲṴṶṸṺỤỦỨỪỬỮỰⓊＵ]/g,
    V: /[VƲɅṼṾⓋꝞＶ]/g,
    VY: /Ꝡ/g,
    W: /[WŴẀẂẄẆẈⓌⱲＷ]/g,
    X: /[XẊẌⓍＸ]/g,
    Y: /[YÝŶŸƳȲɎẎỲỴỶỸỾⓎＹ]/g,
    Z: /[ZŹŻŽƵȤẐẒẔⓏⱫⱿꝢＺ]/g,
    a: /[aàáâãäåāăąǎǟǡǻȁȃȧɐḁẚạảấầẩẫậắằẳẵặⓐⱥａ]/g,
    aa: /ꜳ/g,
    ae: /[æǣǽ]/g,
    ao: /ꜵ/g,
    au: /ꜷ/g,
    av: /[ꜹꜻ]/g,
    ay: /ꜽ/g,
    b: /[bƀƃɓḃḅḇⓑｂ]/g,
    c: /[cçćĉċčƈȼḉↄⓒꜿｃ]/g,
    d: /[dďđƌɖɗḋḍḏḑḓⓓꝺｄ]/g,
    dz: /[ǆǳ]/g,
    e: /[eèéêëēĕėęěǝȅȇȩɇɛḕḗḙḛḝẹẻẽếềểễệⓔｅ]/g,
    f: /[fƒḟⓕꝼｆ]/g,
    g: /[gĝğġģǥǧǵɠᵹḡⓖꝿꞡｇ]/g,
    h: /[hĥħȟɥḣḥḧḩḫẖⓗⱨⱶｈ]/g,
    hv: /ƕ/g,
    i: /[iìíîïĩīĭįıǐȉȋɨḭḯỉịⓘｉ]/g,
    j: /[jĵǰɉⓙｊ]/g,
    k: /[kķƙǩḱḳḵⓚⱪꝁꝃꝅꞣｋ]/g,
    l: /[lĺļľŀłſƚɫḷḹḻḽⓛⱡꝇꝉꞁｌ]/g,
    lj: /ǉ/g,
    m: /[mɯɱḿṁṃⓜｍ]/g,
    n: /[nñńņňŉƞǹɲṅṇṉṋⓝꞑꞥｎ]/g,
    nj: /ǌ/g,
    o: /[oòóôõöøōŏőơǒǫǭǿȍȏȫȭȯȱɔɵṍṏṑṓọỏốồổỗộớờởỡợⓞꝋꝍｏ]/g,
    oi: /ƣ/g,
    ou: /ȣ/g,
    oo: /ꝏ/g,
    p: /[pƥᵽṕṗⓟꝑꝓꝕｐ]/g,
    q: /[qɋⓠꝗꝙｑ]/g,
    r: /[rŕŗřȑȓɍɽṙṛṝṟⓡꝛꞃꞧｒ]/g,
    s: /[sßśŝşšșȿṡṣṥṧṩẛⓢꞅꞩｓ]/g,
    t: /[tţťŧƭțʈṫṭṯṱẗⓣⱦꞇｔ]/g,
    tz: /ꜩ/g,
    u: /[uùúûüũūŭůűųưǔǖǘǚǜȕȗʉṳṵṷṹṻụủứừửữựⓤｕ]/g,
    v: /[vʋʌṽṿⓥꝟｖ]/g,
    vy: /ꝡ/g,
    w: /[wŵẁẃẅẇẉẘⓦⱳｗ]/g,
    x: /[xẋẍⓧｘ]/g,
    y: /[yýÿŷƴȳɏẏẙỳỵỷỹỿⓨｙ]/g,
    z: /[zźżžƶȥɀẑẓẕⓩⱬꝣｚ]/g
  };
  var parsedString = input;
  Object.entries(removalMap).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    parsedString = parsedString.replace(value, key);
  });
  return parsedString;
}

function removeEmojis(input) {
  var baseEmojiRegex = /[\u2700-\u27bf]|\ud83c[\udde6-\uddff]{2}|[\ud800-\udbff][\udc00-\udfff]/;
  var variationSelectorRegex = /[\ufe0e\ufe0f]?/;
  var modifierRegex = /[\u0300-\u036f\u20d0-\u20f0\ufe20-\ufe23]|\ud83c[\udffb-\udfff]/;
  var zeroWidthJoinerRegex = /\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\u20d0-\u20f0\ufe20-\ufe23]|\ud83c[\udffb-\udfff])?/;
  var emojiRegex = new RegExp("(?:".concat(baseEmojiRegex.source, ")").concat(variationSelectorRegex.source, "(?:").concat(modifierRegex.source, ")?(?:").concat(zeroWidthJoinerRegex.source, ")*"), "g");
  return input.replace(emojiRegex, "").trim();
}

function removeEmptyTags(input) {
  return input.replace(/<[^/>][^>]*>\s*<\/[^>]+>/gi, "");
}

function removeNonPrintableCharacters(input) {
  return input.replace(/[^\x20-\x7E´\u00C0-\u00FFˆ˜]+/g, "");
}

function removeTags(input) {
  return input.replace(/(<([^>]+)>)/gi, "");
}

function removeWhitespace(input) {
  return input.replace(/\r\n|\r|\n|\t/g, "").replace(/ +/g, " ");
}

function slugify(input) {
  return removeAccents(input).replace(/[\u0300-\u036f]/g, "").replace(/[()]/g, "").replace(/ /g, "-").replace(/["%<>\\^`{|}]/g, "").toLowerCase();
} // src/date.ts


var MINUTE = 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var WEEK = DAY * 7;
var MONTH = DAY * 30;
var YEAR = 365 * DAY;

function isIsoDate(input) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(input)) {
    return false;
  }

  var date = new Date(input);
  return date.toISOString() === input;
}

function isoDate(input) {
  if (typeof input !== "undefined") {
    return new Date(input).toISOString();
  }

  return /* @__PURE__ */new Date().toISOString();
}

function isValidDate(input) {
  var date = is2.date(input) ? input : new Date(input);
  return !Number.isNaN(date.getTime());
}

function now() {
  return Math.floor(Date.now() / 1e3);
}

function timeSince(input, options) {
  var _ref4 = options || {},
      _ref4$day = _ref4.day,
      day = _ref4$day === void 0 ? "day" : _ref4$day,
      days = _ref4.days,
      _ref4$hour = _ref4.hour,
      hour = _ref4$hour === void 0 ? "hour" : _ref4$hour,
      hours = _ref4.hours,
      _ref4$minute = _ref4.minute,
      minute = _ref4$minute === void 0 ? "minute" : _ref4$minute,
      minutes = _ref4.minutes,
      _ref4$month = _ref4.month,
      month = _ref4$month === void 0 ? "month" : _ref4$month,
      months = _ref4.months,
      prefix = _ref4.prefix,
      _ref4$second = _ref4.second,
      second = _ref4$second === void 0 ? "second" : _ref4$second,
      seconds = _ref4.seconds,
      _ref4$skipWeeks = _ref4.skipWeeks,
      skipWeeks = _ref4$skipWeeks === void 0 ? false : _ref4$skipWeeks,
      _ref4$suffix = _ref4.suffix,
      suffix = _ref4$suffix === void 0 ? "ago" : _ref4$suffix,
      _ref4$week = _ref4.week,
      week = _ref4$week === void 0 ? "week" : _ref4$week,
      weeks = _ref4.weeks,
      _ref4$year = _ref4.year,
      year = _ref4$year === void 0 ? "year" : _ref4$year,
      years = _ref4.years;

  var date = typeof input === "number" ? input : timestamp(input);
  var diff = now() - date;
  var quantity = Math.floor(diff / YEAR);

  var output = function output(value, caption) {
    var result = "".concat(value, " ").concat(caption);

    if (prefix) {
      result = "".concat(prefix, " ").concat(result);
    }

    if (suffix) {
      result = "".concat(result, " ").concat(suffix);
    }

    return result;
  };

  if (quantity >= 1) {
    return output(quantity, pluralize(quantity, year, years));
  }

  quantity = Math.floor(diff / MONTH);

  if (quantity > 1) {
    return output(quantity, pluralize(quantity, month, months));
  }

  if (!skipWeeks) {
    quantity = Math.floor(diff / WEEK);

    if (quantity > 1) {
      return output(quantity, pluralize(quantity, week, weeks));
    }
  }

  quantity = Math.floor(diff / DAY);

  if (quantity >= 1) {
    return output(quantity, pluralize(quantity, day, days));
  }

  quantity = Math.floor(diff / HOUR);

  if (quantity >= 1) {
    return output(quantity, pluralize(quantity, hour, hours));
  }

  quantity = Math.floor(diff / MINUTE);

  if (quantity > 1) {
    return output(quantity, pluralize(quantity, minute, minutes));
  }

  return output(Math.floor(diff), pluralize(diff, second, seconds));
}

function timestamp(input) {
  if (!input) {
    return now();
  }

  var date = typeof input === "string" ? new Date(input) : input;
  return Math.floor(date.getTime() / 1e3);
} // src/devices.ts


function isDarkMode() {
  return !!window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
}

function isTouchDevice() {
  return !!window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
}

function prefersReducedMotion() {
  return !!window.matchMedia && window.matchMedia("prefers-reduced-motion").matches;
} // src/formatters.ts


function formatBoolean(input) {
  return input ? "Yes" : "No";
}

function formatCPF(value) {
  var clearValue = cleanupNumericString(value);

  if (clearValue.length >= 10) {
    return "".concat(clearValue.slice(0, 3), ".").concat(clearValue.slice(3, 6), ".").concat(clearValue.slice(6, 9), "-").concat(clearValue.slice(9, 11));
  } else if (clearValue.length >= 7) {
    return "".concat(clearValue.slice(0, 3), ".").concat(clearValue.slice(3, 6), ".").concat(clearValue.slice(6, 9));
  } else if (clearValue.length >= 4) {
    return "".concat(clearValue.slice(0, 3), ".").concat(clearValue.slice(3, 6));
  }

  return clearValue;
}

function formatDateLocale(input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$locale = options.locale,
      locale = _options$locale === void 0 ? "en-GB" : _options$locale,
      _options$showTime = options.showTime,
      showTime = _options$showTime === void 0 ? false : _options$showTime;
  var formatOptions = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit"
  };

  if (showTime) {
    formatOptions.hour = "2-digit";
    formatOptions.minute = "2-digit";
  }

  return new Date(input).toLocaleDateString(locale, formatOptions);
}

function formatMoney(input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$decimalChar = options.decimalChar,
      decimalChar = _options$decimalChar === void 0 ? "." : _options$decimalChar,
      _options$showCents = options.showCents,
      showCents = _options$showCents === void 0 ? false : _options$showCents,
      _options$symbol = options.symbol,
      symbol = _options$symbol === void 0 ? "$" : _options$symbol,
      _options$thousandsCha = options.thousandsChar,
      thousandsChar = _options$thousandsCha === void 0 ? "," : _options$thousandsCha;
  var isNegative = input < 0;
  var value = Math.abs(input);

  var _value$toFixed$split = value.toFixed(2).split("."),
      _value$toFixed$split2 = _slicedToArray(_value$toFixed$split, 2),
      amount = _value$toFixed$split2[0],
      cents = _value$toFixed$split2[1];

  var padStart = amount.length > 3 ? amount.length % 3 : 0;
  var initial = amount.slice(0, padStart);
  var remain = amount.slice(padStart).replace(/(\d{3})(?=\d)/g, "$1".concat(thousandsChar));
  var formatted = "".concat(remain);

  if (initial) {
    formatted = "".concat(initial).concat(thousandsChar).concat(remain);
  }

  if (cents !== "00" || showCents) {
    formatted += "".concat(decimalChar).concat(cents);
  }

  return "".concat(isNegative ? "-" : "").concat(symbol).concat(formatted);
}

function formatPhoneBR(input) {
  var phone = input.replace(/\D/g, "");

  if (phone.length === 8) {
    return phone.replace(/^(\d{4})(\d{4}).*/, "$1-$2");
  }

  if (phone.length === 9) {
    return phone.replace(/^(\d{5})(\d{4}).*/, "$1-$2");
  }

  if (phone.length === 10 || phone.length === 11) {
    return phone.replace(/^(\d{2})(\d{4,5})(\d{4}).*/, "($1) $2-$3");
  }

  return phone;
}

function formatPhoneUS(input) {
  var phone = input.replace(/\D/g, "");

  if (phone.length === 10) {
    return phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, "($1) $2-$3");
  }

  if (phone.length === 11 && phone.startsWith("1")) {
    return phone.replace(/^1(\d{3})(\d{3})(\d{4}).*/, "+1 ($1) $2-$3");
  }

  return phone;
}

function formatPostalCodeBR(value) {
  var clearValue = cleanupNumericString(value);

  if (clearValue.length >= 6) {
    return "".concat(clearValue.slice(0, 5), "-").concat(clearValue.slice(5, 8));
  }

  return clearValue;
} // src/functions.ts


function demethodize(fn) {
  return function (parameter) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    return fn.apply(parameter, rest);
  };
}

function measureExecutionTime(_x3) {
  return _measureExecutionTime.apply(this, arguments);
}

function _measureExecutionTime() {
  _measureExecutionTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(callback) {
    var start, result, end, total;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            start = performance.now();
            _context4.next = 3;
            return callback();

          case 3:
            result = _context4.sent;
            end = performance.now();
            total = end - start;
            console.log("Completed in ".concat(Math.ceil(total), " milliseconds"));
            return _context4.abrupt("return", result);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _measureExecutionTime.apply(this, arguments);
}

function noop() {
  return void 0;
}

function once(fn) {
  var done = false;
  var result;
  return function Fn() {
    if (!done) {
      done = true;
      result = fn.apply(void 0, arguments);
    }

    return result;
  };
}

function pipe() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (input) {
    return fns.reduce(function (previousValue, fn) {
      return fn(previousValue);
    }, input);
  };
} // src/misc.ts


import is3 from "is-lite"; // src/numbers.ts

function ceil(input) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var factor = Math.pow(10, digits);
  return Math.ceil(input * factor) / factor;
}

function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  return Math.min(Math.max(value, min), max);
}

function floor(input) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var factor = Math.pow(10, digits);
  return Math.floor(input * factor) / factor;
}

function pad(input) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return "".concat(input).padStart(length, "0");
}

function randomNumber() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  if (min >= max) {
    return max;
  }

  return Math.floor(Math.random() * (max - min + 1) + min);
}

function round(input) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var factor = Math.pow(10, digits);
  return Math.round(input * factor) / factor;
} // src/misc.ts


function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

function conditional(cases, defaultCase) {
  var _iterator = _createForOfIteratorHelper(cases),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          expression = _step$value[0],
          callback = _step$value[1];

      if (expression) {
        return callback();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return defaultCase === null || defaultCase === void 0 ? void 0 : defaultCase();
}

function copyToClipboard(_x4) {
  return _copyToClipboard.apply(this, arguments);
}

function _copyToClipboard() {
  _copyToClipboard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(input) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return navigator.clipboard.writeText(input);

          case 3:
            _context5.next = 8;
            break;

          case 5:
            _context5.prev = 5;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", false);

          case 8:
            return _context5.abrupt("return", true);

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 5]]);
  }));
  return _copyToClipboard.apply(this, arguments);
}

function getDataType(input) {
  var toLowerCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var dataTypeName = Object.prototype.toString.call(input).slice(8, -1);
  var output = dataTypeName;

  if (/HTML\w+Element/.test(dataTypeName)) {
    output = "HTMLElement";
  }

  return toLowerCase ? output.toLowerCase() : output;
}

function invariant(condition, message) {
  if (condition) {
    return;
  }

  var value = is3.function(message) ? message() : message;
  throw new Error(value);
}

function isJSON(input) {
  try {
    JSON.parse(input);
  } catch (_unused) {
    return false;
  }

  return true;
}

function isRequired() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "parameter";
  var Constructable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TypeError;
  throw new Constructable("\"".concat(input, "\" is required"));
}

function logger(type, title, data) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$collapsed = options.collapsed,
      collapsed = _options$collapsed === void 0 ? true : _options$collapsed,
      _options$hideTimestam = options.hideTimestamp,
      hideTimestamp = _options$hideTimestam === void 0 ? false : _options$hideTimestam,
      _options$skip = options.skip,
      skip = _options$skip === void 0 ? false : _options$skip,
      _options$typeColor = options.typeColor,
      typeColor = _options$typeColor === void 0 ? "gray" : _options$typeColor;
  var groupMethod = collapsed ? console.groupCollapsed : console.group;
  var date = /* @__PURE__ */new Date();
  var parts = ["%c ".concat(type)];
  var styles = ["color: ".concat(typeColor, "; font-weight: lighter;"), "color: inherit;"];

  if (!hideTimestamp) {
    styles.push("color: gray; font-weight: lighter;");
  }

  var time = "".concat(pad(date.getHours(), 2), ":").concat(pad(date.getMinutes(), 2), ":").concat(pad(date.getSeconds(), 2));
  parts.push("%c".concat(title));

  if (!hideTimestamp) {
    parts.push("%c@ ".concat(time));
  }

  if (!skip) {
    groupMethod.apply(void 0, [parts.join(" ")].concat(styles));
    console.log(data);
    console.groupEnd();
  }
}

function nullify(value) {
  return value !== null && value !== void 0 ? value : null;
}

function popupCenter(url, title, width, height) {
  var _window = window,
      screen = _window.screen,
      screenLeft = _window.screenLeft,
      screenTop = _window.screenTop;
  var screenWidth = window.innerWidth;
  var screenHeight = window.innerHeight;

  if (!screenWidth) {
    screenWidth = document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  }

  if (!screenHeight) {
    screenHeight = document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  }

  var left = screenWidth / 2 - width / 2 + screenLeft;
  var top = screenHeight / 2 - height / 2 + screenTop;
  var popup = window.open(url, title, "menubar=no,location=no,resizable=no,scrollbars=yees,status=no,width=".concat(width, ",height=").concat(height, ",top=").concat(top, ", left=").concat(left));

  if (popup) {
    popup.focus();
  }

  return popup;
}

function px(value) {
  return is3.number(value) || is3.numericString(value) ? "".concat(value, "px") : value;
}

function unique() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$includeLower = options.includeLowercase,
      includeLowercase = _options$includeLower === void 0 ? true : _options$includeLower,
      _options$includeNumbe = options.includeNumbers,
      includeNumbers = _options$includeNumbe === void 0 ? true : _options$includeNumbe,
      _options$includeSymbo = options.includeSymbols,
      includeSymbols = _options$includeSymbo === void 0 ? false : _options$includeSymbo,
      _options$includeUpper = options.includeUppercase,
      includeUppercase = _options$includeUpper === void 0 ? true : _options$includeUpper;
  var lowercase = "abcdefghijklmnopqrstuvwxyz";
  var uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var numbers = "0123456789";
  var symbols = "!?@#$%^&*+_-=:.~";
  var characters = "";

  if (includeLowercase) {
    characters += lowercase;
  }

  if (includeUppercase) {
    characters += uppercase;
  }

  if (includeNumbers) {
    characters += numbers;
  }

  if (includeSymbols) {
    characters += symbols;
  }

  var result = "";

  for (var index = length; index > 0; --index) {
    result += characters[Math.round(Math.random() * (characters.length - 1))];
  }

  return result;
}

function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
} // src/objects.ts


import is4 from "is-lite";

function cleanUpObject(input) {
  var output = {};

  for (var key in input) {
    if (input[key] !== void 0) {
      output[key] = input[key];
    }
  }

  return output;
}

function getNestedProperty(input, path) {
  if (!is4.plainObject(input) && !is4.array(input) || !path) {
    return input;
  }

  var segments = path.split(".");
  var length = segments.length;
  var output = input;

  var _loop = function _loop(index) {
    var currentSegment = segments[index];
    var remainingSegments = segments.slice(index + 1);

    if (currentSegment === "+" && is4.array(output) && remainingSegments.length === 1) {
      return {
        v: output.map(function (d) {
          return d[remainingSegments.join(".")];
        })
      };
    }

    try {
      output = output[currentSegment];
    } catch (_unused2) {}
  };

  for (var index = 0; index < length; index++) {
    var _ret = _loop(index);

    if (typeof _ret === "object") return _ret.v;
  }

  return output;
}

function invertKeys(input) {
  if (!is4.plainObject(input)) {
    throw new TypeError("Expected an object");
  }

  var result = {};

  for (var _i = 0, _Object$entries = Object.entries(input); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    result[value] = key;
  }

  return result;
}

function keyMirror(input) {
  if (!is4.plainObject(input)) {
    throw new TypeError("Expected an object");
  }

  var output = {};

  for (var key in input) {
    if (!Object.prototype.hasOwnProperty.call(output, key)) {
      output[key] = key;
    }
  }

  return output;
}

function mergeProps(defaultProps, props) {
  var cleanProps = cleanUpObject(props);
  return _objectSpread(_objectSpread({}, defaultProps), cleanProps);
}

function objectEntries(input) {
  return Object.entries(input);
}

function objectKeys(input) {
  return Object.keys(input);
}

function objectToArray(input, includeOnly) {
  if (!is4.plainObject(input)) {
    throw new TypeError("Expected an object");
  }

  return Object.entries(input).filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        value = _ref6[1];

    return includeOnly ? typeof value === "".concat(includeOnly) : true;
  }).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    return _defineProperty({}, key, value);
  });
}

function omit(input) {
  if (!is4.plainObject(input)) {
    throw new TypeError("Expected an object");
  }

  var output = {};

  for (var _len3 = arguments.length, filter = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    filter[_key3 - 1] = arguments[_key3];
  }

  for (var key in input) {
    if ({}.hasOwnProperty.call(input, key)) {
      if (!filter.includes(key)) {
        output[key] = input[key];
      }
    }
  }

  return output;
}

function pick(input) {
  if (!is4.plainObject(input)) {
    throw new TypeError("Expected an object");
  }

  for (var _len4 = arguments.length, filter = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    filter[_key4 - 1] = arguments[_key4];
  }

  if (!filter.length) {
    return input;
  }

  var output = {};

  for (var key in input) {
    if ({}.hasOwnProperty.call(input, key)) {
      if (filter.includes(key)) {
        output[key] = input[key];
      }
    }
  }

  return output;
}

function queryStringFormat(input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$addPrefix = options.addPrefix,
      addPrefix = _options$addPrefix === void 0 ? false : _options$addPrefix,
      _options$encoder = options.encoder,
      encoder = _options$encoder === void 0 ? encodeURIComponent : _options$encoder,
      _options$encodeValues = options.encodeValuesOnly,
      encodeValuesOnly = _options$encodeValues === void 0 ? true : _options$encodeValues;

  if (!is4.plainObject(input)) {
    throw new TypeError("input type isn't supported");
  }

  var isValidInput = Object.values(input).every(function (item) {
    if (is4.array(item)) {
      return item.every(function (d) {
        return is4.string(d) || is4.number(d);
      });
    }

    return is4.string(item);
  });

  if (!isValidInput) {
    throw new TypeError("input format isn't supported");
  }

  var output = Object.entries(input).map(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
        key = _ref11[0],
        value = _ref11[1];

    var nextKey = encodeValuesOnly ? key : encoder(key);
    var nextValue = is4.array(value) ? value.map(encoder).join(",") : encoder("".concat(value));
    return "".concat(nextKey, "=").concat(nextValue);
  }).join("&");
  return "".concat(addPrefix ? "?" : "").concat(output);
}

function queryStringParse(input) {
  var search = input;

  if (input.slice(0, 1) === "?") {
    search = input.slice(1);
  }

  return search.split("&").reduce(function (acc, d) {
    var _d$split = d.split("="),
        _d$split2 = _slicedToArray(_d$split, 2),
        key = _d$split2[0],
        value = _d$split2[1];

    acc[decodeURIComponent(key)] = decodeURIComponent(value);
    return acc;
  }, {});
}

function sortObjectKeys(input) {
  return objectKeys(input).sort().reduce(function (acc, key) {
    acc[key] = input[key];
    return acc;
  }, {});
} // src/statistics.ts


import is5 from "is-lite";

function mean(input, precision) {
  var output = input.reduce(function (sum, value) {
    return sum + value;
  }, 0) / input.length;

  if (is5.number(precision)) {
    return round(output, precision);
  }

  return output;
}

function median(input) {
  var sorted = _toConsumableArray(input).sort(function (a, b) {
    return a - b;
  });

  var middle = Math.floor(sorted.length / 2);

  if (sorted.length % 2 === 0) {
    return (sorted[middle - 1] + sorted[middle]) / 2;
  }

  return sorted[middle];
}

function mode(input) {
  var count = /* @__PURE__ */new Map();

  var _iterator2 = _createForOfIteratorHelper(input),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _count$get;

      var value = _step2.value;
      var current = (_count$get = count.get(value)) !== null && _count$get !== void 0 ? _count$get : 0;
      count.set(value, current + 1);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var sorted = _toConsumableArray(count.entries()).sort(function (a, b) {
    return b[1] - a[1];
  });

  return sorted[0][0];
} // src/validators.ts


function isValidCPF(value) {
  if (!value) {
    return false;
  }

  var newValue = value.replace(/[.-]/g, "");
  var sum = 0;
  var rest;

  if (/^(\d)\1+$/.test(newValue)) {
    return false;
  }

  for (var index = 1; index <= 9; index++) {
    sum += parseInt(newValue.substring(index - 1, index), 10) * (11 - index);
  }

  rest = sum * 10 % 11;

  if (rest === 10 || rest === 11) {
    rest = 0;
  }

  if (rest !== parseInt(newValue.substring(9, 10), 10)) {
    return false;
  }

  sum = 0;

  for (var _index = 1; _index <= 10; _index++) {
    sum += parseInt(newValue.substring(_index - 1, _index), 10) * (12 - _index);
  }

  rest = sum * 10 % 11;

  if (rest === 10 || rest === 11) {
    rest = 0;
  }

  return rest === parseInt(newValue.substring(10, 11), 10);
}

function isValidEmail(value) {
  return /^[\w%+.-]+@[\d.a-z-]+\.[a-z]{2,}$/i.test(value);
}

function validatePassword(password, options) {
  var _ref12 = options || {},
      _ref12$maxLength = _ref12.maxLength,
      maxLength = _ref12$maxLength === void 0 ? 64 : _ref12$maxLength,
      _ref12$maxLengthMessa = _ref12.maxLengthMessage,
      maxLengthMessage = _ref12$maxLengthMessa === void 0 ? "Password must be a maximum of 64 characters" : _ref12$maxLengthMessa,
      _ref12$minLength = _ref12.minLength,
      minLength = _ref12$minLength === void 0 ? 6 : _ref12$minLength,
      _ref12$minLengthMessa = _ref12.minLengthMessage,
      minLengthMessage = _ref12$minLengthMessa === void 0 ? "Password must be at least 6 characters long" : _ref12$minLengthMessa,
      _ref12$regex = _ref12.regex,
      regex = _ref12$regex === void 0 ? /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!#$%&*?@^]).*$/ : _ref12$regex,
      _ref12$requiredCharac = _ref12.requiredCharactersMessage,
      requiredCharactersMessage = _ref12$requiredCharac === void 0 ? "Password must have at least 1 number, 1 lowercase, 1 uppercase and 1 special character" : _ref12$requiredCharac;

  if (password.length < minLength) {
    throw new Error(minLengthMessage);
  }

  if (password.length > maxLength) {
    throw new Error(maxLengthMessage);
  }

  if (!regex.test(password)) {
    throw new Error(requiredCharactersMessage);
  }

  return true;
} // src/types.ts


var types_exports = {};
export { ASYNC_STATUS, DAY, HOUR, MINUTE, MONTH, types_exports as Types, WEEK, YEAR, canUseDOM, capitalize, ceil, clamp, cleanUpObject, cleanupHTML, cleanupNumericString, cleanupURI, conditional, copyToClipboard, cors, createArray, demethodize, floor, formatBoolean, formatCPF, formatDateLocale, formatMoney, formatPhoneBR, formatPhoneUS, formatPostalCodeBR, getDataType, getInitials, getNestedProperty, getRandomItem, invariant, invertKeys, isDarkMode, isIsoDate, isJSON, isRequired, isTouchDevice, isValidCPF, isValidDate, isValidEmail, isoDate, keyMirror, logger, mean, measureExecutionTime, median, mergeProps, mode, noop, now, nullify, objectEntries, objectKeys, objectToArray, omit, once, pad, pick, pipe, pluralize, poll, popupCenter, prefersReducedMotion, px, queryStringFormat, queryStringParse, quickSort, randomNumber, removeAccents, removeDuplicates, removeEmojis, removeEmptyTags, removeNonPrintableCharacters, removeTags, removeWhitespace, request, round, shuffle, sleep, slugify, sortByLocaleCompare, sortByPrimitive, sortComparator, sortObjectKeys, splitIntoChunks, timeSince, timestamp, unique, uuid, validatePassword };